import { setCookie, getCookie } from './cookie';

const GOOGLE_ADS_PARAMS = ['gclid', 'gbraid', 'wbraid'] as const;

/**
 * Captures Google Ads tracking parameters (gclid, gbraid, wbraid) from URL
 * and stores them in persistent first-party cookies.
 *
 * If a user returns and books again through an ad, we can overwrite the existing parameter.
 * The parameters persist for 10 years.
 */
export function captureGoogleAdsParams(): void {
    if (typeof window === 'undefined') {
        return;
    }

    const urlParams = new URLSearchParams(window.location.search);

    GOOGLE_ADS_PARAMS.forEach((param) => {
        const value = urlParams.get(param);
        if (value) {
            setCookie(param, value, 3650);
        }
    });
}

/**
 * Retrieves Google Ads tracking parameters from cookies
 */
export function getGoogleAdsParams(): {
    gclid: string | null;
    gbraid: string | null;
    wbraid: string | null;
} {
    return {
        gclid: getCookie('gclid'),
        gbraid: getCookie('gbraid'),
        wbraid: getCookie('wbraid'),
    };
}
